import { Injectable } from "@angular/core";
import { config } from "@config";
import { take } from "rxjs/operators";
import { debug } from "@helpers/debug";
import * as braze from "@braze/web-sdk";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";

@Injectable({
	providedIn: "root"
})
export class BrazeService {
	public constructor(private profileFacade: NewProfileFacade) {}

	public init(): void {
		this.profileFacade
			.getProfile$()
			.pipe(take(1))
			.subscribe((profile) => {
				try {
					braze.initialize(config.braze.apiKey, {
						baseUrl: config.braze.server,
						enableLogging: debug
					});
					braze.automaticallyShowInAppMessages();
					braze.changeUser(profile.profile_id);
					braze.openSession();
				} catch (e) {
					if (debug) {
						console.warn(e);
					}
					// Ignore the error because there is nothing to recover from
				}
			});
	}
}
